import { render, staticRenderFns } from "./trans-scene-info.html?vue&type=template&id=d1867da8&scoped=true&external"
import script from "./trans-scene-info.js?vue&type=script&lang=js&external"
export * from "./trans-scene-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-scene-info.scss?vue&type=style&index=0&id=d1867da8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1867da8",
  null
  
)

export default component.exports